<div class="flex flex-col gap-4" *transloco="let t">
  <div class="flex flex-col gap-3">
    @for (verdict of verdicts; track $index) {
      <div class="flex flex-col gap-3 rounded-xl border p-4">
        <div class="flex items-start justify-between gap-3">
          <div class="type-body text-foreground">
            {{ verdict.description ?? t("dsp-creatives.rejection_without_reason") }}
          </div>
          @if (verdict.moderationStatus === DspModerationStatus.NOT_APPROVED) {
            <IBadge color="red" variant="soft" [label]="t('dsp-creatives.rejected')" />
          } @else {
            <IBadge color="orange" variant="soft" [label]="t('dsp-creatives.partially_rejected')" />
          }
        </div>

        @if (verdict.policyUrl) {
          <a [href]="verdict.policyUrl" target="_blank" rel="noopener" class="link type-body w-fit">
            {{ t("dsp-creatives.read_the_amazon_policy") }}
          </a>
        }

        <button
          type="button"
          class="type-body-medium text-muted-foreground hover:text-foreground flex w-fit cursor-pointer items-center gap-1 transition-colors"
          (click)="toggle($index)"
        >
          <IIcon [name]="isOpen($index) ? 'chevronDown' : 'chevronRight'" />
          {{ t("dsp-creatives.n_impacted_ads", { count: verdict.ads.length }) }}
        </button>

        <IAccordion [isOpen]="isOpen($index)">
          <table iTable>
            <thead iTableHead>
              <tr iTableRow>
                <th iTableTh>{{ t("dsp-stats.line_item") }}</th>
                <th iTableTh>{{ t("dsp-stats.creative") }}</th>
              </tr>
            </thead>
            <tbody iTableBody>
              @for (ad of verdict.ads; track $index) {
                <tr iTableRow>
                  <td iTableTd>{{ ad.adGroupName }}</td>
                  <td iTableTd>{{ ad.creativeName }}</td>
                </tr>
              }
            </tbody>
          </table>
        </IAccordion>
      </div>
    }
  </div>
</div>
